import React from 'react';
import {
    BubbleExChart,
    DoughnutExChart, FunnelExChart,
    PiExChart,
    SimpleBarExChart,
    SplineExChart,
    StackedBarExChart, TreeMapExChart, SimpleCounter, palette, colorSet, source, sourceHit, sourceCompare, sourceLoss, sourceTotal, HealthCheck, QMCounter, SpeedometerChart
} from './DevExtremeWidgets';
import { Spinner } from 'office-ui-fabric-react/lib';
import { getSectionKpi } from "../../../queries/queryReport";

import { Query } from 'react-apollo';

import gql from 'graphql-tag';
import TagCloud from './TagCloud/TagCloud';
const frameStyle = {
    margin: 4 * 2,
    padding: 4 * 2,
    sizeSmal: 76 * 2,
    sizeBig: 178 * 2,
    footer: 40,

};

class DevboardWidgetSectionQM extends React.Component {
    constructor(props) {
        super(props);        
        this.data = null;

    }

    render() {
        
        return (
            this.queryWidget(this.props.element.id, this.props.element, this.props.input, this.props.apol, this.props.sectionName)
        )
    }

    queryWidget = (reportId, element, input, apol, sectionName) => (
        

        <Query
            //key={`query:${element.id}`}
            query={getSectionKpi}
            variables={{ input, reportId, sectionName }}
        >
            {({
                loading, error, data, refetch,
            }) => {
                if (loading) return <Spinner label="Loading..." ariaLive="assertive" labelPosition="top" />;
                
                if (error) return <h1> </h1>;
                    console.log("data ", data)
                if (data.getSectionKpi != null) {
                    //let size_w; let
                    //    size_h;
                    //if (this.props.resize === true) {
                    //    size_h = -1;
                    //    size_w = -1;
                    //} else {
                    //    size_w = frameStyle.sizeBig;
                    //    size_h = frameStyle.sizeBig;
                    //}

                    //let dataTotal = [];
                    //if (data.getSectionKpi.data.total !== null) {
                    //    dataTotal = data.getSectionKpi.data.total;
                    //}
                    //let elementData = null;
                    //let tempArr = [];

                    //elementData = data.getSectionKpi.data.user;
                    //console.log("persons ", this.props.element.persons);
                    //<StackedBarExChart
                    //    palette={palette}
                    //    data={elementData}
                    //    changeSectionInfo={this.props.changeSectionInfo}
                    //    type={this.props.element.type}
                    //    kpi={this.props.element.kpi}
                    //    overflow={data.getSectionKpi.data.overflow}

                    //    size={{
                    //        width: size_w,
                    //        height: size_h,
                    //    }}
                    //    convType={this.props.element.conversationType}
                    //    problemType={this.props.element.problemTypes}
                    //    name={data.getSectionKpi.data.name}
                    //    persons={this.props.element.persons}
                    ///>
                }
                console.log("out")
            }}
        </Query>
    );

}

export default DevboardWidgetSectionQM;